import { StorageError } from "@/infrastructure/errors/StorageError";

export class LocalStorageManager {
  constructor(private readonly prefix: string = "") {}

  private getKey(key: string): string {
    return this.prefix ? `${this.prefix}:${key}` : key;
  }

  get(key: string): string | null {
    try {
      return localStorage.getItem(this.getKey(key));
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new StorageError(`Failed to retrieve data from localStorage: ${message}`);
    }
  }

  set(key: string, value: string): void {
    try {
      localStorage.setItem(this.getKey(key), value);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new StorageError(`Failed to store data in localStorage: ${message}`);
    }
  }

  delete(key: string): void {
    try {
      localStorage.removeItem(this.getKey(key));
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new StorageError(`Failed to delete data from localStorage: ${message}`);
    }
  }
}
